export default {
  mode: "live", // liveかdateか
  selectedCategory: "custom", // 汎用カテゴリー

  // ライブデータx軸ズーム
  liveDataTimeRange: 60,
  liveDataTimeRangeOptions: [60, 45, 30, 15],
  liveDataTimeRangeIndex: 0,

  // チャートx軸ズーム
  xZoomCount: 0,
  // チャートx軸ズーム倍率
  xZoomPercentage: 25,
  xZoomStoredRange: null,

  // チャンネルデータ検索条件
  channelTimeFrom: null, //"2020-10-12T01:55:00.000Z",
  channelTimeTo: null,
  categoryId: null,
  categoryNum: null,
  categoryLayer: "2", // 常にcategory2を検索
  customChannelIds: [], // カスタムレポートの検索IDリスト
  unsubscribes: [],
  unsubscribesForChart: [],
  latestChannelData: {}, // FireStoreに入ってくる最新チャンネルデータの連携用.

  liveModeStartFrom: null, //"2020-10-12T01:55:00.000Z",

  channelMaster: {},
  alertSummaryLiveDatas: [],
  eventSummaryLiveDatas: [],
  prevFirestoreDocument: {},
  referencedChannelIdMap: {}, // 画面参照されたchannelIdをMap型で保持

  kind: {
    engine: {
      originId: "1", // originIdは一時的に固定値で運用
      versionId: "",
    },
    handling: {
      originId: "2",
      versionId: "",
    },
    aisea_alert: {
      originId: "1",
      versionId: "",
    },
  },

  // データ種別ごとのチャンネルIDリスト
  channelGroupData: [ // データ種別
    {
      channelGroup: "custom", // キー `"categoryLayer"+"categoryId"+"categoryNumber"` or 固有値
      categoryName: "カスタムレポート",
      categoryLayer: null,
      categoryId: null,
      categoryNumber: null, 
      channels: {}, // channelId: {name: "name",unit: "unit"}の連想配列
      displayInTrendData: true
    },
    {
      channelGroup: "alert",
      categoryName: "アラートサマリー",
      categoryLayer: null, 
      categoryId: null,
      categoryNumber: null, 
      channels: [],
      displayInTrendData: false
    },
    {
      channelGroup: "event",
      categoryName: "イベントサマリー",
      categoryLayer: null,
      categoryId: null,
      categoryNumber: null, 
      channels: [],
      displayInTrendData: false
    },
    {
      channelGroup: "maneuvering",
      categoryName: "操船データ",
      categoryLayer: null,
      categoryId: null,
      categoryNumber: null, 
      channels: {},
      displayInTrendData: true
    },
    {
      channelGroup: "2/1/1",
      categoryName: "右舷主機",
      categoryLayer: "2", // category2に属する
      categoryId: "1",
      categoryNumber: "1", 
      channels: {},
      displayInTrendData: true
    },
    {
      channelGroup: "2/1/2",
      categoryName: "左舷主機",
      categoryLayer: "2",
      categoryId: "1",
      categoryNumber: "2", 
      channels: {},
      displayInTrendData: true
    },
    {
      channelGroup: "2/2/0",
      categoryName: "軸",
      categoryLayer: "2",
      categoryId: "2",
      categoryNumber: null, 
      channels: {},
      displayInTrendData: true
    },
    {
      channelGroup: "2/3/0",
      categoryName: "CPP",
      categoryLayer: "2",
      categoryId: "3",
      categoryNumber: null, 
      channels: {},
      displayInTrendData: true
    },
    {
      channelGroup: "2/4/0",
      categoryName: "主発電機エンジン",
      categoryLayer: "2",
      categoryId: "4",
      categoryNumber: "0", 
      channels: {},
      displayInTrendData: true
    },
    {
      channelGroup: "2/6/0",
      categoryName: "主発電機",
      categoryLayer: "2",
      categoryId: "6",
      categoryNumber: null, 
      channels: {},
      displayInTrendData: true
    },
    {
      channelGroup: "2/5/0",
      categoryName: "軸発電機",
      categoryLayer: "2",
      categoryId: "5",
      categoryNumber: null, 
      channels: {},
      displayInTrendData: true
    },
  ],
  
  // X軸マウスフォーカスポイント
  channelGroupFocusPointMap: {
    // channelGroup: time
  },

  monitoringVesselEngineStart: 0,  // 描画速度検証用。

  // アラート発生時間
  // { "1030": '2021-11-08T06:49:26.000Z' }
  alertOccurTimeMap: {}
}